export const TAG_TYPE = {
  CONTACT: 'contact',
  INSTITUTION: 'institution',
  FUND: 'fund',
  SECURITY: 'security',
  ACTIVITY: 'activity'
}
